import { setTimeout } from 'timers';
import * as CONSTANTS from '../constants/constants';

export const getCourses = () => (
  dispatch,
  getState,
  { getFirestore }
) => {
  const firestore = getFirestore();
  const courses = []
  const courseRef = firestore.collection(CONSTANTS.COURSES).where("asDraft", "==", false);
  // const courseRef = firestore.collection(CONSTANTS.COURSES)

  courseRef.get().then((querySnapshot) => {
    // var size = querySnapshot.size
    // console.log(size)
    querySnapshot.forEach((course) => {
      courses.push(Object.assign(course.data(), { id: course.id }));
    });
    dispatch({ type: CONSTANTS.GET_COURSES, courses });
  }).catch((e) => {
    // eslint-disable-next-line no-console
    console.log('error', e);
  });
};

export const getMyCourses = () => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  const firebase = getFirebase();
  const firestore = getFirestore();
  const user = firebase.auth().currentUser;
  if(user !== null) {
    const userRef = firestore.collection(CONSTANTS.USERS).doc(user.uid);
    const coursespoolRef = userRef.collection('coursespool')
    let coursespool = []
    let courses = []
    coursespoolRef.get().then((querySnapshot) => {
      querySnapshot.forEach((course) => {
        coursespool.push(Object.assign(course.data(), { uid: course.id }));
      });
      // console.log(coursespool.length)
      if(coursespool.length > 0) {
        coursespool.forEach((cour) => {
          const courseRef = firestore.collection(CONSTANTS.COURSES).doc(cour.courseId);
          courseRef.get().then((snapshot) => {
            if(snapshot.exists){
              const course = Object.assign(snapshot.data(), { id: snapshot.id });
            courses.push(course)
            }
          })
        })
        dispatch({ type: CONSTANTS.GET_MYCOURSES, courses });
      } else {
        dispatch({ type: CONSTANTS.GET_MYCOURSES, courses });
      }
    })
  }
};

export const getDrafts = () => (
  dispatch,
  getState,
  { getFirestore }
) => {
  const firestore = getFirestore();
  const courses = []
  const courseRef = firestore.collection(CONSTANTS.COURSES).where("asDraft", "==", true);

  courseRef.get().then((querySnapshot) => {
    querySnapshot.forEach((course) => {
      courses.push(Object.assign(course.data(), { id: course.id }));
    });
    dispatch({ type: CONSTANTS.GET_DRAFT_COURSES, courses });
  }).catch((e) => {
    // eslint-disable-next-line no-console
    console.log('error', e);
  });
};

export const getCourse = courseId => (
  dispatch,
  getState,
  { getFirestore }
) => {
  const firestore = getFirestore();
  const courseRef = firestore.collection(CONSTANTS.COURSES).where("slug", "==", courseId);
  courseRef.get().then((snapshot) => {
    console.log(snapshot)
    if(snapshot.empty) {
      dispatch({ type: CONSTANTS.SHOWERROR_PAGE})
    } else {
      snapshot.forEach((doc) => {
        const course = Object.assign(doc.data(), { id: doc.id });
        dispatch({ type: CONSTANTS.GET_COURSE, course });
      })
    }
  }).catch((e) => {
    console.log('error', e);
  });
};

export const getSections = courseId => (
  dispatch,
  getState,
  { getFirestore }
) => {
  const firestore = getFirestore();
  const sections = [];
  const userId = window.localStorage.uid
  const courseRef = firestore.collection(CONSTANTS.COURSES);
  const findSect = courseRef.where("slug", "==", courseId);

  findSect.get().then((snap) => {
    snap.forEach((doc) => {
      const sectionRef = courseRef.doc(doc.id).collection('sections');
      sectionRef.get().then((querySnapshot) => {
        querySnapshot.forEach((section) => {
          sections.push(Object.assign(section.data(), { id: section.id, lectures: [] }));
        });
        sections.map((section) => {
          const lectureRef = sectionRef.doc(section.id).collection('lectures');
          lectureRef.get().then((lectures) => {
            lectures.forEach((lecture) => {
              //check for lecture completed collection
              var completed = false;
              if (userId) lectureRef.doc(lecture.id).collection('completed')
                .where("userId", "==", userId).get().then((snap) => {
                  if (snap.docs.length) {
                    completed = true
                  }
                  section.lectures.push(Object.assign(lecture.data(), { id: lecture.id }, { completed }));
                }); else section.lectures.push(Object.assign(lecture.data(), { id: lecture.id }, { completed }));


              //
            });
          });
          return sections;
        });
        setTimeout(() => dispatch({ type: CONSTANTS.GET_SECTIONS, sections }), 3000);
      })
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.log('error', e);
        });
    })
  })


};

export const getLastView =  (userID) => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  const firebase = getFirebase();
  const firestore = getFirestore();
  const fsUserRef = firestore.collection("users").doc(userID);
  const lastViewedRef = fsUserRef.collection('lastViewed');
  const fsCourseRef = firestore.collection(CONSTANTS.COURSES)
  try {
      var course = {}
      lastViewedRef.get().then((view)=>{
        view.forEach((doc) => {
          if(doc.id){
           var data = Object.assign(doc.data(), { id: doc.id })
           fsCourseRef.doc(data.courseId).get().then((snap)=>{
            if(snap.exists){
              window.snap = snap
            course = Object.assign(snap.data(), { id: snap.id ,currentTime:data.currentTime,lastLectId:data.lectureId})
            dispatch({ type: CONSTANTS.SET_LAST_VIEW_COURSE,payload:course })
            } 
         })
          }
        
        });
      })

    } catch (error) {
      console.log(error)
    }
    // return dispatch({ type: CONSTANTS.SET_LAST_VIEW_COURSE,payload:course })
  
}